import React, { useEffect, useRef, useState } from 'react';
import { Grid, Stack, GridProps } from '@mui/material';
import NumberWidget from 'components/Widgets/NumberWidget';
import ChartWidget from 'components/Widgets/ChartWidget';
import QueryIcon from '../../assets/query.svg';
import PageHeader from 'components/Header/Page';
import { useCacheDataController } from 'Context/contexts/CacheDataContext';
import DateFilterDropdown from 'components/Dropdown/DateFilter';
import '../TableauObs/Summary/Summary.scss';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';
import { getDecodedToken, getSector, QuerySummaryTable, fetchQuerySummary, fetchDEQueryTrends } from '../../service/service';
import '../DataEstate/data-estate.scss';
import { CustomizedDataGrid } from '../customized_data_grid';
import { Column } from 'react-data-grid';
import { isEnvTypePROD } from '../../service/config';
import LoaderComponent from 'components/Loader';
import PageWrapper from 'components/Common/PageWraper';
import HighlightedText from 'components/GlobalSearch/HighlightText';

const gridChildProps: GridProps = {
	minWidth: '260px',
	flexGrow: 1,
	flexBasis: 0,
	maxWidth: '100%'
};

function formatNumber(number: any) {
	if (number != null && !isNaN(number)) {
		return Number(number).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
	} else {
		return '0.00';
	}
}
const QueriesSummary = () => {
	const [searchParams] = useSearchParams();
	const hasDrillDown = searchParams.has('isDrillDowned');
	const [controller] = useCacheDataController();
	const { teradataStorageLastSyncDate } = controller;
	// sector filter
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const [, setFilterMenu] = useState<{
		mouseX: number;
		mouseY: number;
	} | null>(null);
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [, setCheckedList] = useState<any[]>([]);
	const [, setCurrSectorFilter] = useState<any[]>([]);
	const [sector] = useState<any[]>([]);
	const dataFetchedRef = useRef(false);
	const [TeradataSize, SetTeradataSize] = useState('-');
	const [PrestoSize, SetPrestoSize] = useState('-');
	const [dimension, setDimension] = useState<any>();

	// Dummy data for Presto Query Trend
	// const dummyPrestoData: { [key: string]: number } = {
	// 	'2025-01': 12400, '2025-02': 13200, '2025-03': 14800, '2025-04': 13900,
	// 	'2025-05': 15600, '2025-06': 16200, '2025-07': 15100, '2025-08': 17300,
	// 	'2025-09': 18500, '2025-10': 17800, '2025-11': 19200, '2025-12': 20100,
	// 	'2026-01': 19500, '2026-02': 21000, '2026-03': 22400, '2026-04': 21800,
	// 	'2026-05': 23600, '2026-06': 24200
	// };

	// // Dummy data for Teradata Query Trend
	// const dummyTeradataData: { [key: string]: number } = {
	// 	'2025-01': 8500, '2025-02': 8200, '2025-03': 7900, '2025-04': 7600,
	// 	'2025-05': 7300, '2025-06': 7100, '2025-07': 6800, '2025-08': 6500,
	// 	'2025-09': 6200, '2025-10': 5900, '2025-11': 5700, '2025-12': 5400,
	// 	'2026-01': 5100, '2026-02': 4800, '2026-03': 4500, '2026-04': 4200,
	// 	'2026-05': 3900, '2026-06': 3600
	// };

	// const [grafanaPrestoLoading, setGrafanaPrestoLoading] = useState(false);
	// const [grafanaPrestoOptions, setGrafanaPrestoOptions] = useState<any>(dummyPrestoData);
	// const [grafanaTeradataLoading, setGrafanaTeradataLoading] = useState(false);
	// const [grafanaTeradataOptions, setGrafanaTeradataOptions] = useState<any>(dummyTeradataData);
	// const [lastUpdatedDateTeradata, setLastUpdatedDateTeradata] = useState(moment().utc().format('YYYY-MM-DD'));
	// const [lastUpdatedDatePresto, setLastUpdatedDatePresto] = useState(moment().utc().format('YYYY-MM-DD'));


	const [grafanaPrestoLoading, setGrafanaPrestoLoading] = useState(true);
	const [grafanaPrestoOptions, setGrafanaPrestoOptions] = useState<any>();
	const [grafanaTeradataLoading, setGrafanaTeradataLoading] = useState(true);
	const [grafanaTeradataOptions, setGrafanaTeradataOptions] = useState<any>();
	const [lastUpdatedDateTeradata, setLastUpdatedDateTeradata] = useState('');
	const [lastUpdatedDatePresto, setLastUpdatedDatePresto] = useState('');
	const [filterMonth, setFilterMonth] = useState('0M');

	async function fetchSectorOptionsData() {
		const sectorRes = await getSector('1', '100', '');
		if (sectorRes.success) {
			const filteredSectorOptions = sectorRes.data.sector.filter((x: any) => x.name !== 'S&T').map((x: any) => x.name);
			filteredSectorOptions.push('Blank');
			setSectorOptionsList(filteredSectorOptions);
		}
	}

	async function getQuerySummaryDetails(sectors: any, month: any) {
		let sector = sectors.length == sectorOptionsList.length ? [] : sectors;
		// Trend APIs
		SetTeradataSize('-');
		SetPrestoSize('-');
		const todaysDate = moment().utc().format('YYYY-MM-DD');
		fetchDEQueryTrends('query', 'presto', sector, month)
			.then((res) => {
				setGrafanaPrestoOptions(res?.data.data);
				setLastUpdatedDatePresto(res?.data.lastUpdatedDate ? res.data.lastUpdatedDate : todaysDate);
				setGrafanaPrestoLoading(false);
			})
			.catch((error: any) => {
				console.error(error);
			});

		// Teradata
		fetchDEQueryTrends('query', 'teradata', sector, month)
			.then((res) => {
				setGrafanaTeradataOptions(res?.data.data);
				setLastUpdatedDateTeradata(res?.data.lastUpdatedDate ? res.data.lastUpdatedDate : todaysDate);
				setGrafanaTeradataLoading(false);
			})
			.catch((error: any) => {
				console.error(error);
			});

		// Summary APIs
		fetchQuerySummary('presto', sector, month)
			.then((res) => {
				let prestoSize = 0;
				if (res?.data?.result[0]?.prestoQueries) {
					prestoSize = res?.data?.result[0]?.prestoQueries;
					SetPrestoSize((prestoSize / 1000).toFixed(2).toString());
				} else {
					SetPrestoSize('0');
				}
			})
			.catch((error) => {
				console.error(error);
			});

		fetchQuerySummary('teradata', sector, month)
			.then((res) => {
				let teradataSize = 0;
				if (res?.data?.result[0]?.teradataQueries) {
					teradataSize = res?.data?.result[0]?.teradataQueries;
					SetTeradataSize((teradataSize / 1000).toFixed(2).toString());
				} else {
					SetTeradataSize('0');
				}
			})
			.catch((error) => {
				console.error(error);
			});
	}

	useEffect(() => {
		if (hasDrillDown) {
			const selectedSector = localStorage.getItem('selectedSector');
			if (selectedSector) {
				const selectedSec = JSON.parse(selectedSector).length ? JSON.parse(selectedSector) : '';
				setCheckedList(selectedSec);
				setCurrSectorFilter(selectedSec);
			}
		} else {
			localStorage.removeItem('selectedSector');
		}

		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;
		if (userSector === 'all') fetchSectorOptionsData();
		const activeId = document.getElementById('root');
		if (window.location.pathname === '/dataestate/queriessummary') {
			if (activeId) {
				document.head.classList.add('theme-bg-blue');
				document.body.classList.add('theme-bg-blue');
				document.body.classList.add('custom-class');
				activeId.classList.add('jobs-list-table');
				activeId.classList.remove('jobs-list');
				activeId.classList.remove('root');
				document.body.classList.add('jobs-exe-datas');
				document.body.classList.remove('jobs-run-table');
				document.body.classList.add('jobs-list-datas');
				document.body.classList.add('datefilter-align-sector');
				document.body.classList.add('sector-label');
			}
		} else {
			if (activeId) {
				document.body.classList.remove('jobs-list-datas');
				activeId.classList.add('root');
				document.body.classList.add('dashboard-panel-dataestate');
				document.body.classList.add('datefilter-align-sector');
			}
		}
		getQuerySummaryDetails(sector, filterMonth);
	}, []);

	useEffect(() => {
		const onDateChange = (event: any) => {
			const selectedDate = event?.detail?.selectedDate;
			if (selectedDate) {
				setFilterMonth(selectedDate);
				clearMetricsSummary();
				getQuerySummaryDetails(sector, selectedDate);
			}
		};
		window.addEventListener('dataEstateDateChanged', onDateChange);
		return () => {
			window.removeEventListener('dataEstateDateChanged', onDateChange);
		};
	}, [sector]);

	// table
	const [tableName, setTableName] = useState('');
	const [typeName, setTypeName] = useState('');
	interface PRESTO {
		batchId_UsedId: string;
		queryDuration: string;
		greaterThanTenMin: string;
		queryStartTime: string;
		queryEndTime: string;
	}
	interface TERADATA {
		batchId_UsedId: string;
		queryDuration: string;
		queryStartTime: string;
		ueryEndTime: string;
	}
	interface Row { }
	function getColumns(): Array<Column<Row>> {
		if (typeName === 'PRESTO') {
			return [
				{
					key: 'batchId_UsedId',
					name: 'Batch Id/Used Id',
					minWidth: 150
				},
				{
					key: 'queryDuration',
					name: 'Query duration',
					minWidth: 170
				},
				{
					key: 'queryDetails',
					name: 'Query details',
					minWidth: 170
				},
				{
					key: 'greaterThanTenMin',
					name: '>10 Mins?',
					minWidth: 170
				},
				{
					key: 'queryStartTime',
					name: 'Query start time',
					minWidth: 170
				},
				{
					key: 'queryEndTime',
					name: 'Query end time',
					minWidth: 170
				}
			];
		} else if (typeName === 'TERADATA') {
			return [
				{
					key: 'batchId_UsedId',
					name: 'Batch Id/Used Id',
					minWidth: 150
				},
				{
					key: 'queryDuration',
					name: 'Query duration',
					minWidth: 170
				},
				{
					key: 'queryStartTime',
					name: 'Query start time',
					minWidth: 170
				},
				{
					key: 'ueryEndTime',
					name: 'Query end time',
					minWidth: 170
				}
			];
		} else {
			return [];
		}
	}
	const PrestoColumns = [
		'Batch Id/Used Id',
		'Query duration',
		'Query details',
		'>10 Mins?',
		'Query start time',
		'Query end time'
	];
	const teradataColumns = ['Batch Id/Used Id', 'Query duration', 'Query start time', 'Query end time'];
	const [defaultColumnNames, setDynamicValue] = useState(['']);
	const [tableData, setTableData] = useState<Row[]>([]);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: '', sortDir: '' });
	const [paginationData, setPaginationData] = useState({ totalElements: 0, totalPages: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [isDetailVisible, setIsDetailVisible] = useState(false);
	const handlePageChange = (event: React.ChangeEvent<unknown>, value: number) => {
		summaryListingFunc(value, pageSize, sortingInfo, dimension);
	};
	const handlepageSizeChange = (event: any) => {
		summaryListingFunc(page, event.target.value, sortingInfo, dimension);
	};
	async function summaryListingFunc(pageNumber: any, size: any, sortingInfo: any, dimension: any) {
		const res = await QuerySummaryTable('query', dimension, sector, '1M');
		if (res.success) {
			console.log(res.data, 'resdata');
			setTableData(res.data);
			if (res.data.page) {
				setPaginationData(res.data.page);
			}
			setPage(pageNumber);
			setPageSize(size);
			setSortingInfo(sortingInfo);
		}
	}
	const handleSorting = (sortingInfo: any) => {
		summaryListingFunc(page, pageSize, sortingInfo, dimension);
	};
	const handleOnclick = (value: any) => {
		setDynamicValue(['']);
		setTableData([]);
		setIsDetailVisible(true);
		setTypeName(value);
		if (value === 'PRESTO') {
			setDimension('presto');
			setDynamicValue(PrestoColumns);
			type Row = keyof PRESTO;
			setTableName('Presto Queries');
		}
		if (value === 'TERADATA') {
			setDynamicValue(teradataColumns);
			type Row = keyof TERADATA;
			setTableName('Teradata Queries');
			setDimension('teradata');
		}
		summaryListingFunc(page, pageSize, sortingInfo, dimension);
	};

	const clearMetricsSummary = () => {
		setTableData([]);
		setIsDetailVisible(false);
	};

	const handleDateChange = (selectedDate: string) => {
		clearMetricsSummary();
		getQuerySummaryDetails(sector, selectedDate);
	};

	return (
		<PageWrapper>
			<PageHeader title="Query Summary" icon={QueryIcon} lastSync={teradataStorageLastSyncDate}>
				{/* Code for Date filter moved to HeaderTabs */}
				{/* <DateFilterDropdown
					customMonth={customMonth}
					filterMonth={filterMonth}
					setCustomMonth={setCustomMonth}
					setFilterMonth={setFilterMonth}
					handleChange={handleDateChange}
				/> */}
			</PageHeader>
			<Stack p={{ md: 2 }} mt={4}>
				<Grid container gap={2} display="flex" flexDirection="row" flexWrap="wrap">
					<Grid {...gridChildProps} id="presto-queries">
						<NumberWidget
							title={<HighlightedText text="Presto Queries" />}
							tooltipLabel={''}
							//hasTooltip={false}
							number={formatNumber(PrestoSize)}
							units="k"
							bgColor="#FBFDFF"
							color="#000000"
							valueFontWeight={300}
							sameDecimalSize={true}
							isLoading={PrestoSize === '-'}
							handleEvent={isEnvTypePROD ? undefined : () => handleOnclick('PRESTO')}
						/>
					</Grid>
					<Grid {...gridChildProps} id="teradata-queries">
						<NumberWidget
							title={<HighlightedText text="Teradata Queries" />}
							tooltipLabel={''}
							//asTooltip={false}
							number={formatNumber(TeradataSize)}
							units="k"
							bgColor="#FBFDFF"
							color="#000000"
							valueFontWeight={300}
							sameDecimalSize={true}
							isLoading={TeradataSize === '-'}
							handleEvent={isEnvTypePROD ? undefined : () => handleOnclick('TERADATA')}
						/>
					</Grid>
				</Grid>

				<Grid container mt={2} spacing={2}>
					<Grid item xs={12} md={6} id="presto-query-trend">
						<ChartWidget
							title={<HighlightedText text="Presto Query Trend" />}
							data={grafanaPrestoOptions}
							isLoading={grafanaPrestoLoading}
							lastUpdatedDate={lastUpdatedDatePresto}
							titleColor="#000000"
							chartBgColor="#FBFDFF"
							lineColor="#003771"
							isDataEstateQuery={true}
						/>
					</Grid>

					<Grid item xs={12} md={6} id="teradata-query-trend">
						<ChartWidget
							title={<HighlightedText text="Teradata Query Trend" />}
							data={grafanaTeradataOptions}
							isLoading={grafanaTeradataLoading}
							hasBadge={false}
							lastUpdatedDate={lastUpdatedDateTeradata}
							titleColor="#000000"
							chartBgColor="#FBFDFF"
							lineColor="#003771"
							isDataEstateQuery={true}
						/>
					</Grid>
				</Grid>
				{isDetailVisible && (
					<>
						<h2 className="panel-legend--title mt-35 ">{tableName}</h2>
						<div className=" dataestate_tabledata">
							<Grid>
								{tableData.length > 0 ? (
									<CustomizedDataGrid
										tableColumns={getColumns()}
										tableData={tableData}
										tableType="sector"
										defaultColumnNames={defaultColumnNames}
										onSorting={handleSorting}
										currSorting={sortingInfo}
										page={page}
										pageSize={pageSize}
										paginationData={paginationData}
										listLength={tableData.length}
										handlepageSizeChange={handlepageSizeChange}
										handlePageChange={handlePageChange}
										isDateRangeFilter={false}
										isDisabled={false}
									/>
								) : (
									<LoaderComponent />
								)}
							</Grid>
						</div>
					</>
				)}
			</Stack>
		</PageWrapper>
	);
};

export default QueriesSummary;
